import { BaseModel } from "./_Index";

export class Role extends BaseModel{}